var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('confirm',{ref:"confirm"}),_c('confirm-delete',{ref:"confirmDelete"}),_c('erp-data-dialog',{ref:"erpDataDialog"}),_c('plan-selection',{ref:"changePlan",on:{"modelChanged":function($event){return _vm.$emit('modelChanged')}}}),_c('request-cancellation',{ref:"requestCancellation"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }